export default __webpack_public_path__ + "static/media/pciu_logo.4fb63ddd.png";